var viVN = {
  locale: 'vi_VN',
  direction: 'ltr',
  date: {
    defaultFormat: {
      week: 'WW/YYYY',
      date: 'DD/MM/YYYY',
      month: 'MM/YYYY',
      year: 'YYYY',
      time: 'HH:mm:ss',
      dateTime: 'DD/MM/YYYY HH:mm:ss'
    },
    startDay: 0,
    shortMonthList: ['Tháng 1', 'Tháng 2', 'Tháng 3', 'Tháng 4', 'Tháng 5', 'Tháng 6', 'Tháng 7', 'Tháng 8', 'Tháng 9', 'Tháng 10', 'Tháng 11', 'Tháng 12'],
    monthList: ['Tháng 1', 'Tháng 2', 'Tháng 3', 'Tháng 4', 'Tháng 5', 'Tháng 6', 'Tháng 7', 'Tháng 8', 'Tháng 9', 'Tháng 10', 'Tháng 11', 'Tháng 12'],
    shortDayList: ['CN', 'T2', 'T3', 'T4', 'T5', 'T6', 'T7'],
    dayList: ['CN', 'T2', 'T3', 'T4', 'T5', 'T6', 'T7'],
    shortestDayList: ['CN', 'T2', 'T3', 'T4', 'T5', 'T6', 'T7']
  },
  'dynamic-date': {
    day: 'Ngày',
    week: 'Tuần',
    month: 'Tháng',
    quarter: 'Quý',
    year: 'Năm',
    before: 'Trước ${value}${unit}'
  },
  'auto-complete.empty': 'Không có dữ liệu',
  'select.selected-count': 'Đã chọn ${count} mục',
  'date-time-picker.date': 'Chọn ngày',
  'image-view.zoom-out': 'Thu nhỏ',
  'input.placeholder': 'Vui lòng nhập',
  'empty.text': 'Không có dữ liệu',
  'date-picker.cancel': 'Hủy',
  'date-picker.end': 'Thời gian kết thúc',
  'cascader.empty': 'Không có dữ liệu',
  'upload.drop': 'Kéo tệp tin vào đây hoặc',
  'color.custom': 'Tùy chỉnh màu',
  'cascader.titles': ['Cấp 1', 'Cấp 2', 'Cấp 3', 'Cấp 4', 'Cấp 5', 'Cấp 6', 'Cấp 7', 'Cấp 8'],
  'date-comparison.error-target': 'Chọn thời gian kết thúc so sánh',
  'transfer.empty': 'Không có dữ liệu',
  'select.search.placeholder': 'Vui lòng nhập',
  'upload.click': 'Nhấp để tải lên',
  'date-time-picker.placeholder': 'Vui lòng nhập',
  'pager.jump': 'Chuyển hướng',
  'tree-select.placeholder': 'Vui lòng nhập',
  'dynamic-date.interval': 'Khoảng cách thời gian',
  'modal.cancel': 'Hủy',
  'image-view.rotate': 'Xoay',
  'tabs.more': 'Khác',
  'popover.ok': 'Xác nhận',
  'transfer.placeholder': 'Vui lòng nhập',
  'date.month': 'Tháng',
  'select.selected': 'Đã chọn',
  'popover.cancel': 'Hủy',
  'image-view.prev': 'Trước',
  'table.emptyText': 'Không có dữ liệu',
  'date-time-picker.ok': 'Xác nhận',
  'table.filter.confirm': 'Xác nhận',
  'tree-select.empty': 'Không có dữ liệu',
  'dynamic-date.fixed-date': 'Ngày cố định',
  'date-comparison.compare': 'So sánh',
  'auto-complete.placeholder': 'Vui lòng nhập',
  'time-picker.placeholder': 'Chọn thời gian',
  'date.month-first': true,
  'select.clear': 'Xóa',
  'date.year': '${year}',
  'date-comparison.yoy': 'Khoảng thời gian này năm ngoái',
  'image-view.zoom-to-origin': 'Ban đầu',
  'schedule.title': 'Ngày/Giờ',
  'schedule.clear': 'Xóa',
  'date-time-picker.end': 'Chọn ngày và giờ kết thúc',
  'dynamic-date.customize': 'Tùy chỉnh',
  'date-picker.apply': 'Áp dụng',
  'schedule.selected': 'Thời gian đã chọn',
  'dynamic-date.dynamic-date': 'Ngày động',
  'select.placeholder': 'Vui lòng chọn',
  'schedule.separator': ',',
  'cascader.search': 'Vui lòng nhập',
  'date-picker.invalid-range': 'Khoảng thời gian đã chọn vượt quá phạm vi có thể lựa chọn. Vui lòng chọn khoảng thời gian hợp lệ.',
  'dynamic-date.date-preview': 'Xem trước ngày',
  'select.empty': 'Không có dữ liệu',
  'image-view.next': 'Tiếp theo ',
  'date-time-picker.now': 'Bây giờ',
  'date-time-picker.time': 'Chọn thời gian',
  'tree.empty': 'Không có dữ liệu',
  'pager.total': 'Tổng cộng ${total} bản ghi',
  'image-view.zoom-in': 'Phóng to',
  'date-picker.placeholder': 'Chọn ngày',
  'textarea.placeholder': 'Vui lòng nhập',
  'date.week': 'Tuần',
  'pager.size': '${count} bản ghi/trang',
  'modal.ok': 'Xác nhận',
  'date-picker.start': 'Thời gian bắt đầu',
  'table.filter.reset': 'Đặt lại',
  'image-view.zoom-to-fit': 'Vừa khít',
  'pager.page.placeholder': 'Vui lòng nhập',
  'select.select-all': 'Chọn tất cả',
  'list-viewer.empty': 'Không có dữ liệu',
  'date-comparison.compare-text': 'So với',
  'transfer.source': 'Danh sách nguồn',
  'date-time-picker.start': 'Chọn ngày và giờ bắt đầu',
  'date-comparison.error-source': 'Chọn thời gian bắt đầu so sánh',
  'upload.error.overflow-count': 'Đã vượt quá số tệp tin tối đa',
  'date-comparison.placeholder': 'Thời gian bắt đầu - Thời gian kết thúc',
  'time-range-picker.placeholder': 'Thời gian bắt đầu - Thời gian kết thúc',
  'date-comparison.mom': 'So với khoảng thời gian trước',
  'transfer.target': 'Danh sách đích'
};
export default viVN;